import { render, staticRenderFns } from "./Requirements.vue?vue&type=template&id=c30bcd9a&scoped=true&lang=pug&"
import script from "./Requirements.vue?vue&type=script&lang=ts&"
export * from "./Requirements.vue?vue&type=script&lang=ts&"
import style0 from "./Requirements.vue?vue&type=style&index=0&id=c30bcd9a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c30bcd9a",
  null
  
)

export default component.exports